import { render, staticRenderFns } from "./RoutinesForm.vue?vue&type=template&id=1f2e159d&scoped=true"
import script from "./RoutinesForm.vue?vue&type=script&lang=js"
export * from "./RoutinesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e159d",
  null
  
)

export default component.exports